import { AuthState } from '@packages/@types/authContext';
import { Role } from '../../../types/Auth';
import PermissionRules from '../../../config/rbac-rules';
import { ClientFeatureConfig, JSONTransform } from '../../../types/Feature';

// eslint-disable-next-line import/prefer-default-export
export const isFormActionAllowedByPermission = (user: AuthState['user'] | null, permission: string): boolean => {
    if (user && user.role) {
        return (
            PermissionRules[user.role as Role].static?.some(
                (permissionRule: string) => permissionRule === permission,
            ) || false
        );
    }
    return false;
};

export const getJsonTransformFeatureToDelete = (
    formData: Record<string, any>,
    originalData: ClientFeatureConfig<JSONTransform>[],
    user: AuthState['user'] | null,
): Array<number> | undefined => {
    let jsonTransformToDelete: Array<number> | undefined;
    if (user && [Role.StuartStaff, Role.SE].some((role) => user.role === role)) {
        jsonTransformToDelete = originalData.reduce(
            (acc: number[], cur: ClientFeatureConfig<JSONTransform>) =>
                formData.jsonTransform?.some((f: any) => f.id && f.id === cur.id) ? acc : [...acc, cur.id],
            [],
        );
    }

    return jsonTransformToDelete;
};
